import { c as _c } from "react/compiler-runtime";
import { Timeline } from '@chakra-ui/react';
import type { CrmActivityItem } from '@src/components/sco/Admin/AiCrm/data/types';
import { CrmRich } from '@src/components/sco/Admin/AiCrm/ui/CrmRich';
import React from 'react';

/** "Recent activity" and "Every interaction": a dot per event, orange when it is held for a person. */
export function CrmTimeline(props) {
  const $ = _c(4);
  let t0;
  if ($[0] !== props.items) {
    t0 = props.items.map(_temp);
    $[0] = props.items;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <Timeline.Root size="sm" variant="plain">{t0}</Timeline.Root>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function _temp(item) {
  return <Timeline.Item key={item.key}><Timeline.Connector><Timeline.Separator /><Timeline.Indicator bg="colorPalette.solid" borderWidth={0} boxSize={2.5} colorPalette={item.hot ? "orange" : "purple"} /></Timeline.Connector><Timeline.Content gap={0.5} pb={2}><Timeline.Title color="fg" fontSize="sm" fontWeight="normal" lineHeight="1.4"><CrmRich text={item.title} /></Timeline.Title><Timeline.Description color="fg.subtle" fontSize="xs">{item.meta}</Timeline.Description></Timeline.Content></Timeline.Item>;
}